import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { firebaseAuth } from '../services/firebase-auth';

const EmailVerification = () => {
    const [status, setStatus] = useState<'success' | 'error'>('success');
    const navigate = useNavigate();

    useEffect(() => {
        const checkVerificationStatus = async () => {
            try {
                // Obtener el usuario actual
                const user = firebaseAuth.getCurrentUser();

                if (user) {
                    await user.reload();

                    if (user.emailVerified) {
                        setStatus('success');
                        setTimeout(() => {
                            navigate('/app/auth');
                        }, 3000);
                    } else {
                        setStatus('error');
                    }
                } else {
                    setStatus('error');
                }
            } catch (error) {
                console.error('Error checking verification status:', error);
                setStatus('error');
            }
        };

        checkVerificationStatus();
    }, [navigate]);

    return (
        <div className="max-w-md mx-auto mt-10 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-center mb-4">Verificación de Email</h2>

            {status === 'success' && (
                <div className="text-center text-green-600">
                    <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <p className="text-lg">¡Email verificado exitosamente!</p>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        Redirigiendo a la página de inicio de sesión...
                    </p>
                </div>
            )}

            {status === 'error' && (
                <div className="text-center text-red-600">
                    <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <p className="text-lg">Error en la verificación</p>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        La verificación del email no se pudo completar.
                        Por favor, solicita un nuevo enlace de verificación.
                    </p>
                    <button
                        onClick={() => navigate('/app/auth')}
                        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                        Ir al Login
                    </button>
                </div>
            )}
        </div>
    );
};

export default EmailVerification;